export default new Map([
  ['A1PA6795UKMFR9', 'DE'],
  ['ARBP9OOSHTCHU', 'EG'],
  ['A2VIGQ35RCS4UG', 'AE'],
  ['A21TJRUUN4KGV', 'IN'],
  ['A1VC38T7YXB528', 'JP'],
  ['APJ6JRA9NG5V4', 'IT'],
  ['A1AM78C64UM0Y8', 'MX'],
  ['AAHKV2X7AFYLW', 'CN'],
  ['A13V1IB3VIYZZH', 'FR'],
  ['A1RKKUPIHCS9HS', 'ES'],
  ['A17E79C6D8DWNP', 'SA'],
  ['A2Q3Y263D00KWC', 'BR'],
  ['A2NODRKZP88ZB9', 'SE'],
  ['A19VAU5U5O7RUS', 'SG'],
  ['A39IBJ37TRP1C6', 'AU'],
  ['A1F83G8C2ARO7P', 'UK'],
  ['A1C3SOZRARQ6R3', 'PL'],
  ['A1805IZSGTT6HS', 'NL'],
  ['A33AVAJ2PDY3EV', 'TR'],
  ['A2EUQ1WTGCTBG2', 'CA'],
  ['ATVPDKIKX0DER', 'US'],
  ['AUJPM9XGFJRC7', 'EG'],
  ['A34GYYCZVDBSIK', 'AE'],
  ['A2XZLSVIQ0F4JT', 'IN'],
  ['A3HOBANJMCMD83', 'IT'],
  ['A3P3J5A7D2ZVXI', 'MX'],
  ['AJZF8LZ1EJVJN', 'ES'],
  ['A1MQPSGJ6U9Q54', 'SA'],
  ['AZXD3QD5B39HD', 'BR'],
  ['AT614YYYNOC1S', 'SE'],
  ['A1DQ6JV7I20JSG', 'SG'],
  ['A1RNPCQ4K8U27I', 'AU'],
  ['AKY4K4WKH21YQ', 'PL'],
  ['A1M3WC0SJ3A38T', 'NL'],
  ['A3CQBQD3RGPJR8', 'TR'],
  ['A1YFOMBPFBRY22', 'BE'],
  ['AMEN7PMS3EDWL', 'BE'],
  ['A3PJZM0QIA8QDU', 'NG'],
  ['A3TFQ1G9L8TQ5L', 'ZA'],
  ['AE08WJ6YKNBMC', 'ZA'],
  ['A2IDBVIE7EAGN4', 'CL'],
  ['A1NOHO22DE3OHQ', 'CO'],
]);
